import logo from './logo.svg';
import './App.css';

import { useEffect, useState } from 'react'

import {Container} from '@material-ui/core'
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

import Grid from '@material-ui/core/Grid';

import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
//import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';

import FileBrowser from './FileBrowser'
import S3Browser from './S3Browser'
import SharesBrowser from './SharesBrowser'
//import AuthComponent from './Auth'
import Doc from './Doc'

const axios = require('axios');
const publicUrl = process.env.REACT_APP_GOZ_PUBLIC_URL || '';
const backend = process.env.REACT_APP_GOZ_BACKEND_URL || publicUrl



function App() {

  // 0: shares, 1: swift
  const [fileAccess, setFileAccess] = useState(0)
  const [uploads, setUploads] = useState([])
  const [token, setToken] = useState(null)
  const [sidebarOpen, setSideBarOpen] = useState(true);
  const handleViewSidebar = () => {
    setSideBarOpen(!sidebarOpen);
  };
  
  const [refresh, setRefresh] = useState(0)

  const upload = async (files, to, token)=> {
    let nbuploads = 0;
    let nbfiles = files.length
    for(let i=0; i<nbfiles;i++) {
      let from = files[i]
      let f = {name: from.name, from: from, to: to, status: 'pending', progress: 0, token: token, ts: new Date()}
      // console.debug('upload', f)
      setUploads([f])
      try {
        await uploadFile(f);
        nbuploads++
      } catch {
        console.error('file uploaded failed', f)
      }
      // console.debug('done', f)

    }
    let status = 'completed'
    if (nbuploads !== nbfiles) {
      status = 'error'
    }
    let f = {name: 'over', status: status, progress: nbuploads/nbfiles*100, ts: new Date()}
    setUploads([f])
    setRefresh(Date.now())
  }

  const upload2s3 = (url, from, to, token)=> {
    let f = {s3 :url, name: from.name, from: from, to: to, status: 'pending', progress: 0, token: token}
    // console.debug('add to download', f)
    setUploads([f])
    uploadFile2s3(f).then(() => {
      setRefresh(Date.now())
    })
  }

  const onLogin = (token) => {
    setToken(token)
  }

  const onLogout = () => {
    setToken(null)
  }

  const uploadFile2s3 = (f) => {
    return new Promise((resolve, reject) => {
      const config = {
        onUploadProgress: function(progressEvent) {
          if (!uploads.length===0) {return}
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          let u = [...uploads];
          u[0].progress = percentCompleted
          setUploads(u) 
        },
        headers: {
          'X-Auth-Token': f.token
        }
      }
      let data = new FormData()
      data.append('file', f.from)
      let u = [...uploads];
      u[0].status = 'uploading'
      let dest = `${f.to}${f.name}`
      
      axios.put(`${f.s3}/${dest}`, data, config)
        .then(res => {
          let u = [...uploads];
          u[0].status = 'completed'
          u[0].progress = 100
          setUploads(u)
          resolve()
        })
        .catch(err => {
          let u = [...uploads];
          u[0].progress = 0
          u[0].status = 'error'
          if (err.response) {
            u[0].status = err.response.data
          }
          setUploads(u)
          reject()
        })
    })
  }


  const uploadFile = (f) => {
    return new Promise((resolve, reject) => {
      const config = {
        onUploadProgress: function(progressEvent) {
          if (uploads.length === 0) {return}
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          let u = [...uploads];
          u[0].progress = percentCompleted
          setUploads(u) 
        },
        headers: {
          'Authorization': 'Bearer ' + f.token
        }
      }
      let data = new FormData()
      data.append('file', f.from)
      // console.debug('upload to ', f.to)

      axios.post(`${backend}/api/upload${f.to}/${f.name}`, data, config)
        .then(() => {
          f.progress = 100
          f.status = 'completed'
          setUploads([f])
          // console.debug('uploaded', f)
          resolve();
        })
        .catch(err => {
          f.progress = 0
          f.status = 'error'
          if (err.response) {
            f.status = err.response.data
          }
          setUploads([f])
          // console.debug('upload error', f)
          reject();
        })

    })
  }

  return (
    <div className="App">
      <header className="App-header">
        HomeAndCo
      </header>
      <Container maxWidth="lg">
      <Grid container spacing={1}>
      {!sidebarOpen && <Grid item xs={12} md={1}>
        <Grid container>
        <Grid item xs={12} md={1}>
        <Button variant="contained" color="secondary" fullWidth size="small" onClick={handleViewSidebar} className="sidebar-toggle">
        &#62;&#62;&#62;
        </Button>
        </Grid>
        </Grid> 
      </Grid>
      }
      <Router>
      {sidebarOpen && <Grid item xs={12} md={2}>
        <Grid container>
        <Grid item xs={12}>
        <Box className="left-action"><Button variant="contained" color="secondary" fullWidth size="small" onClick={handleViewSidebar} className="sidebar-toggle">
        &#60;&#60;&#60;
        </Button></Box>
        </Grid>          
        <Grid item xs={12}><Box className="left-action"><Button fullWidth size="small" variant="contained" color="primary"><Link to="/file/" style={{ color: '#FFF' }}>Files</Link></Button></Box></Grid>
        <Grid item xs={12}><Box className="left-action"><Button fullWidth size="small" variant="contained" color="primary"><Link to="/s3/" style={{ color: '#FFF' }}>Objects</Link></Button></Box></Grid>
        <Grid item xs={12}><Box className="left-action"><Button fullWidth size="small" variant="contained" color="primary"><Link to="/shares" style={{ color: '#FFF' }}>Shares</Link></Button></Box></Grid>
        <Grid item xs={12}><Box className="left-action"><Button fullWidth size="small" variant="contained" color="primary"><Link to="/doc" style={{ color: '#FFF' }}>Doc</Link></Button></Box></Grid>


        
        {uploads.length > 0 && <Grid item xs={12}><Box className="left-action">
          <div>Uploads</div>
          {uploads.map((u,i) => (
            <div key={i}>
              <Card xs={12}>
                <CardContent>
                <Typography color="textSecondary" gutterBottom>
                {u.ts.toLocaleTimeString()}
                </Typography>
                {u.name} [{u.progress}%] {u.status}
                </CardContent>
              </Card>
            </div>           
          ))}
        </Box></Grid> }
        </Grid>
      </Grid>
      }

<Switch>
      <Route exact path="/file/" render={() => (
        <Grid item xs={12} md={10} ><FileBrowser onLogin={onLogin} onLogout={onLogout} refresh={refresh} upload={upload}/></Grid>
      )}/>
      <Route exact path="/s3/" render={() => (
        <Grid item xs={12} md={10} ><S3Browser upload={upload2s3}/></Grid>
      )}/>
      <Route path="/file/:gotoroute+" render={() => (
        <Grid item xs={12} md={10} ><FileBrowser onLogin={onLogin} onLogout={onLogout} refresh={refresh} upload={upload}/></Grid>
      )}/>
      <Route path="/s3/:gotoroute+" render={() => (
        <Grid item xs={12} md={10} ><S3Browser upload={upload2s3}/></Grid>
      )}/>
      <Route path="/shares" render={() => (
        <Grid item xs={12} md={10} ><SharesBrowser token={token}/></Grid>
      )}/>
      <Route path="/doc" render={() => (
        <Grid item xs={12} md={10} ><Doc/></Grid>
      )}/>
      
</Switch>
      </Router>

      </Grid>
      </Container>
    </div>
  );
}

export default App;
